<template>
  <div class="button-group expanded-for-small" :class="{'expanded': expanded}">
      <button class="button button-radio secondary" v-for="choice in choices" :key="choice.key"
        :class="buttonRadioClasses(choice.key)"
        :value="choice.key"
        :id="getAnalyticsId(choice.key)"
        @click="emitChoice(choice.key)"
        @focus="onfocus()"
      >
        {{ choice.description }}
      </button>
  </div>
</template>

<script>
export default {
  name: 'button-radio-selector',
  props: {
    options: {
      type: Array
    },
    optionsAnalyticsData: {
      type: Object
    },
    value: [Boolean, String],
    expanded: {
      type: Boolean
    }
  },
  data() {
    return {
      choices: this.options
        ? this.options
        : [
          {
            key: true,
            description: 'Yes'
          },
          {
            key: false,
            description: 'No'
          }
        ]
    };
  },
  methods: {
    getAnalyticsId(choiceKey) {
      if (this.optionsAnalyticsData) {
        return this.optionsAnalyticsData[choiceKey] || null;
      }
    },
    emitChoice(choice) {
      this.$emit('input', choice);
    },
    buttonRadioClasses(key) {
      return {
        'hollow': (this.value === undefined) || (this.value !== key),
        'selected': this.value === key,
        'has-selection': this.value !== undefined
      };
    },
    onfocus() {
      this.scrollToActiveElement();
      this.$emit('focus');
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/variables.scss';
  .button-group {
    justify-content: flex-end;
    @include breakpoint (medium) {
      .button-group.stacked-for-small .button {
        flex: 0 0 100%;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/forms/button-radio-selector.vue